import { render } from "./App.vue?vue&type=template&id=0f1ff148"
const script = {}

import exportComponent from "/mnt/e/Laravel/kit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__